<template>
  <span :class="`ico-${ico_ref}`"></span>
</template>

<script>
export default {
	props: {
		name: {
			type: String
		}
	},

	data() {
		return {
      'icoLookup': {
        'Mental Health': 'sector-mental-heath',
        'Children / families': 'sector-families',
        'Local / Community': 'sector-community',
        'Young people': 'sector-young-people',
        'Education': 'sector-education',

        'Trustee/Governor':	'vol-type-trustee',
        'Ongoing role':	'vol-type-short-term-proj',
        'Short term project':	'vol-type-ongoing-proj',

        'Strategic development and planning': 'vol-cat-planning',
        'Governance': 'vol-cat-gov',
        'Financial management': 'vol-cat-finance',
        'General / operations management': 'vol-cat-ops',
        'Mentoring / Coaching': 'vol-cat-mentoring'
      }
		}
	},
	computed: {
		ico_ref() {
			if (this.icoLookup[this.name] !== undefined) {
				return this.icoLookup[this.name];
			}
			return 'default';
		}
	}
}
</script>
